import(/* webpackMode: "eager" */ "/app/app/[locale]/legal/cookies/page.tsx");
